import { ICreateGestaoEpiUseCase } from "../../../presentation/useCases/create/create_gestao_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";


export class CreateGestaoEpiUseCase implements ICreateGestaoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async createGestaoEpi(
    nome: string,
    ativo: number | null,
    especificacao: string | null
  ): Promise<number> {
    return await this.repository.createGestaoEpi(
      nome,
      ativo,
      especificacao
    );
  }
}